import { Component, Input, OnInit } from '@angular/core';
import { PaymentSettings } from 'src/app/features/settings/components/payment/models/PaymentMoldes';
import { PaymentService } from 'src/app/features/settings/components/payment/services/Payment.service';
import { Currency } from 'src/app/models/Lookup';

@Component({
  selector: 'app-payment-methods',
  templateUrl: './payment-methods.component.html'
})
export class PaymentMethodsComponent implements OnInit {
  @Input() restaurantId: any;
  dataLoading = true;
  details!: PaymentSettings;
  defaultCurrency!: Currency | undefined;

  constructor(
    private service: PaymentService,
  ) { }

  ngOnInit(): void {
    this.getDetails()
  }

  getDetails() {
    this.dataLoading = true;
    this.service.GetPaymentSettings(this.restaurantId).subscribe(
      (data: PaymentSettings) => {
        this.dataLoading = false;
        if (data) {
          this.details = data;
          this.defaultCurrency = this.details.currencies.find(item => item.isDefault);
        }
      },
      (error: any) => {
        this.dataLoading = false;
      });
  }
}
